var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1257 0.625977C9.72747 0.625977 7.38309 1.33714 5.38903 2.66952C3.39497 4.00191 1.84078 5.89569 0.923019 8.11137C0.00525395 10.3271 -0.234875 12.7651 0.232997 15.1173C0.70087 17.4694 1.85573 19.63 3.55154 21.3258C5.24735 23.0216 7.40794 24.1765 9.7601 24.6444C12.1123 25.1122 14.5503 24.8721 16.766 23.9544C18.9817 23.0366 20.8755 21.4824 22.2079 19.4883C23.5402 17.4943 24.2514 15.1499 24.2514 12.7517C24.2476 9.5369 22.9689 6.45489 20.6957 4.1817C18.4225 1.90851 15.3405 0.629769 12.1257 0.625977ZM16.2121 16.838C16.0053 17.0447 15.725 17.1608 15.4327 17.1608C15.1404 17.1608 14.8601 17.0447 14.6534 16.838L11.3464 13.531C11.1396 13.3243 11.0234 13.044 11.0234 12.7517V6.13766C11.0234 5.8453 11.1395 5.56492 11.3462 5.35819C11.553 5.15146 11.8333 5.03532 12.1257 5.03532C12.4181 5.03532 12.6984 5.15146 12.9052 5.35819C13.1119 5.56492 13.228 5.8453 13.228 6.13766V12.2953L16.2121 15.2793C16.4187 15.486 16.5348 15.7664 16.5348 16.0587C16.5348 16.351 16.4187 16.6313 16.2121 16.838Z",
    fill: "#0E94CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f2c11bff232b2101464d6fbcc8a8cc79.svg";
export { ForwardRef as ReactComponent };